<template>
  <div
    :class="mode == 'input' ? 'card' : ''"
    :style="
      mode == 'input'
        ? 'padding: 30px 20px;box-shadow: 1px 1px 3px 1px #ddd;margin: 20px 0;background: #fff;text-align: left;'
        : 'padding: 20px 0'
    "
  >
    <div class="input-group mb-3">
      <span class="input-group-text"
        >取車分行<span class="asterisk red" v-if="mode == 'input'"
          >*</span
        ></span
      >
      <select class="form-select" v-model="selectedPickupBranch">
        <option :value="{}" selected>請選擇</option>
        <option
          v-for="(item, idx) in pickupBranchList"
          :key="idx"
          :value="item"
          :selected="item.selected"
        >
          {{ item.name }}
        </option>
      </select>
      <button
        class="btn btn-secondary"
        type="button"
        @click.stop="goToBranchWebsite(selectedPickupBranch.website)"
      >
        分行詳情
      </button>
    </div>
    <div style="padding-left: 2px">
      地址：{{
        selectedPickupBranch.address != undefined
          ? selectedPickupBranch.address
          : "未選擇取車分行"
      }}
    </div>
    <div class="input-group mb-3" style="margin-top: 30px">
      <span class="input-group-text"
        >還車分行<span class="asterisk red" v-if="mode == 'input'"
          >*</span
        ></span
      >
      <select class="form-select" v-model="selectedReturnBranch">
        <option :value="{}" selected>請選擇</option>
        <option
          v-for="(item, idx) in returnBranchList"
          :key="idx"
          :value="item"
          :selected="item.selected"
        >
          {{ item.name }}
        </option>
      </select>
      <button
        class="btn btn-secondary"
        type="button"
        @click.stop="goToBranchWebsite(selectedReturnBranch.website)"
      >
        分行詳情
      </button>
    </div>
    <div style="padding-left: 2px">
      地址：{{
        selectedReturnBranch.address != undefined
          ? selectedReturnBranch.address
          : "未選擇還車分行"
      }}
    </div>
    <h5 style="margin-top: 30px">額外服務</h5>
    <div
      class="form-check"
      v-for="(item, idx) in carOptionList"
      :key="idx"
      style="margin: 3px 0"
    >
      <input
        class="form-check-input"
        type="checkbox"
        v-model="checkedCarOptions"
        :value="item"
        :id="'label_' + idx"
      />
      <label class="form-check-label" :for="'label_' + idx" style="color: #222">
        {{ item.description }} ({{ item.typeDescription }})
      </label>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import useEventBus from "@/config/eventBus";

export default {
  props: {
    pickupBranchList: {
      type: Array,
      required: true,
    },
    returnBranchList: {
      type: Array,
      required: true,
    },
    carOptionList: {
      type: Array,
      required: true,
    },
    preSelectedPickupBranch: {
      type: Object,
      required: false,
    },
    preSelectedReturnBranch: {
      type: Object,
      required: false,
    },
    preCheckedCarOptions: {
      type: Array,
      required: false,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const eventBus = useEventBus();
    const selectedPickupBranch = ref({});
    const selectedReturnBranch = ref({});
    const checkedCarOptions = ref([]);

    const goToBranchWebsite = (_website) => {
      if (_website != undefined) {
        window.open(_website);
      }
    };

    watch(selectedPickupBranch, () => {
      eventBus.emit("selectedPickupBranch", {
        id:
          Object.keys(selectedPickupBranch.value).length > 0
            ? selectedPickupBranch.value.id
            : 0,
        name:
          Object.keys(selectedPickupBranch.value).length > 0
            ? selectedPickupBranch.value.name
            : "未選擇",
      });
    });

    watch(selectedReturnBranch, () => {
      eventBus.emit("selectedReturnBranch", {
        id:
          Object.keys(selectedReturnBranch.value).length > 0
            ? selectedReturnBranch.value.id
            : 0,
        name:
          Object.keys(selectedReturnBranch.value).length > 0
            ? selectedReturnBranch.value.name
            : "未選擇",
      });
    });

    watch(checkedCarOptions, () => {
      eventBus.emit("checkedCarOption", checkedCarOptions.value);
    });

    onMounted(() => {
      selectedPickupBranch.value = {};
      selectedReturnBranch.value = {};
      checkedCarOptions.value = [];
      if (props.mode == "edit" && props.preSelectedPickupBranch != undefined) {
        console.log(props.preSelectedPickupBranch);
        selectedPickupBranch.value = props.preSelectedPickupBranch[0];
      }
      if (props.preSelectedReturnBranch != undefined) {
        console.log(props.preSelectedReturnBranch);
        selectedReturnBranch.value = props.preSelectedReturnBranch[0];
      }
      if (props.preCheckedCarOptions != undefined) {
        console.log(props.preCheckedCarOptions);
        checkedCarOptions.value = props.preCheckedCarOptions;
      }
    });

    return {
      selectedPickupBranch,
      selectedReturnBranch,
      checkedCarOptions,
      goToBranchWebsite,
    };
  },
};
</script>